import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const isValidDateOfBirth = (value: string): string | boolean => {
  const parsedDate = dayjs(value, "MM/DD/YYYY", true);

  if (!parsedDate.isValid()) {
    return "Not a valid date of birth";
  }

  return (
    (dayjs().diff(parsedDate, "year") < 130 && dayjs().isAfter(parsedDate)) ||
    "Not a valid date of birth"
  );
};
